export default __webpack_public_path__ + "static/media/shoT2.934e38b0.jpg";